import { createFileRoute } from '@tanstack/react-router'

import { LoadingIndicator } from '@/core/components/LoadingIndicator'
import { buildPageTitle } from '@/core/utils/buildPageTitle/buildPageTitle'
import { keycloakQueries } from '@/http/api/keycloak'
import { PersonalData } from '@/user/components/Settings/PersonalData'

export const Route = createFileRoute('/user/settings/personal-data')({
  head: () => ({
    meta: [
      {
        title: buildPageTitle({
          titleKey: 'page-title-personal-data',
        }),
      },
    ],
  }),
  loader: async ({ context: { queryClient } }) => {
    await queryClient.ensureQueryData(keycloakQueries.detail())
  },
  component: RouteComponent,
  pendingComponent: () => <LoadingIndicator />,
})

function RouteComponent() {
  return <PersonalData />
}
